import React from 'react';
import ReactDOM from 'react-dom';
import App from './main/app/App';
import './main/assets/style/main.scss'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);


